/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import RoomsList from './RoomsList';
import RoomView from './RoomView';

class MyMessages extends Component {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            exact
            path="/main/messenger"
            render={() => <Redirect from="/" to="/main/messenger/rooms" />}
          />
          <Route path="/main/messenger/rooms" render={() => <RoomsList />} />
          <Route
            path="/main/messenger/room/:roomUuid"
            render={() => <RoomView />}
          />
        </Switch>
      </React.Fragment>
    );
  }
}

MyMessages.propTypes = {};

export default withRouter(MyMessages);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyMessages/MyMessages.js